import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const AddFoodCategoriesSlice = createSlice({
    name: "addFoodCategories",
    initialState,
    reducers: {
        addFoodCategoriesRequest(state) {
            state.loading = true;
        },
        addFoodCategoriesRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        addFoodCategoriesRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        addFoodCategoriesStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    addFoodCategoriesRequest,
    addFoodCategoriesRequestSuccess,
    addFoodCategoriesRequestError,
    addFoodCategoriesStateReset
} = AddFoodCategoriesSlice.actions;

export default AddFoodCategoriesSlice.reducer;
